import React from 'react';
import "./About.css";

const About = () => {
    return (
        <section id="about" className="section">
            <div className="content">
                <h2>About Gracious Group Lending Philippines Corporation</h2>
                <p>
                    Gracious Sales Gracious Group Lending Phils., Corp., is registered with the Securities and Exchange Commission with SEC Reg No CS200711606 and CA No 172.
                    Study Terms and Conditions in the Disclosure Statement before proceeding with the loan transaction. Sa Gracious Group, kayo ang bida!
                </p>
                <p>
                    <strong>Alma Aloveros</strong> is the Loan Consultant of Gracious Group Lending Philippines Corporation. For more information, visit our original site at <a href="https://graciousphils.com/" className="subtle-link">graciousphils.com</a>.
                </p>
            </div>
        </section>
    );
}

export default About;
